// import React from 'react'
// import { WhatsappShareButton, WhatsappIcon, FacebookShareButton, FacebookIcon } from 'react-share'

// interface ShareButtonProps {
//   url: string // URL da página que você deseja compartilhar
//   title: string // Título da página ou alguma mensagem para acompanhar a URL
//   size?: number // O tamanho opcional dos ícones
// }

// const ShareModal: React.FC<ShareButtonProps> = ({ url, title, size = 32 }) => {
//   return (
//     <div>
//       {/* Compartilhar no WhatsApp */}
//       <WhatsappShareButton url={url} title={title} separator=":: ">
//         <WhatsappIcon size={size} round />
//       </WhatsappShareButton>

//       {/* Compartilhar no Facebook */}
//       <FacebookShareButton url={url} title={title}>
//         <FacebookIcon size={size} round />
//       </FacebookShareButton>

//       {/* Adicione mais botões de compartilhamento de outras redes sociais conforme necessário */}
//     </div>
//   )
// }

// export default ShareModal

import React, { useRef, useState } from 'react'
import IconCloseOrange from '../../assets/icons/close_orange.webp'

import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon
} from 'react-share'
import './ShareModal.css' // Importe seu próprio arquivo CSS para estilizar o modal
import { Button, TextInput } from '../common'

interface ShareModalProps {
  url: string
  title: string
  isOpen: boolean
  onClose: () => void
  classNameModal?: string
}

const ShareModal: React.FC<ShareModalProps> = ({ url, title, isOpen, onClose, classNameModal = "" }) => {
  const [successCopyLink, setsuccessCopyLink] = useState<boolean | null>(null)

  if (!isOpen) return null

  const handleCopy = async () => {
    let input = document.querySelector('.input-copy-link-share') as HTMLInputElement
    if (input != null) {
      try {
        await navigator.clipboard.writeText(input.value)
        setsuccessCopyLink(true)
        setTimeout(() => {
          setsuccessCopyLink(null)
        }, 2000);
      } catch (error) {
        setsuccessCopyLink(false)
        setTimeout(() => {
          setsuccessCopyLink(null)
        }, 2000);
      }
    }
  }

  return (
    <div className={"modal-overlay container-modal-share container-responsive-view pt-10 " + classNameModal}>
      <div className="modal modal-share">
        {/* <div className='self-end absolute'>
        <img className='' src={IconCloseOrange}/>
      </div> */}
        <div className="grid grid-cols-5">
          <div className="col-span-4">
            <h3 className="font-bold text-xl">Compartilhe esse empreendimento</h3>
          </div>
          <button className="col-span-1 self-center" onClick={onClose}>
            <img className="m-auto me-0" src={IconCloseOrange} />
          </button>
        </div>
        <hr className="w-full mt-2 border-gray-300" />
        <div className="w-full">
          <h5 className="text-lg">Compartilhe via: </h5>
          <div className="share-buttons gap-5 place-content-center">
            {/* Compartilhar no Facebook */}
            <FacebookShareButton url={url} title={title}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>

            {/* Compartilhar no Twitter */}
            <TwitterShareButton url={url} title={title}>
              <TwitterIcon size={32} round />
            </TwitterShareButton>

            {/* Compartilhar no WhatsApp */}
            <WhatsappShareButton url={url} title={title} separator=":: ">
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>

            {/* Compartilhar por Email */}
            <EmailShareButton url={url} subject={title} body="Veja esta página: ">
              <EmailIcon size={32} round />
            </EmailShareButton>

            {/* Adicione aqui outros botões de compartilhamento conforme necessário */}
          </div>
          <h5 className="text-lg">Ou copie o link: </h5>
          <TextInput.Root className="">
            <TextInput.Icon>
              {/* <MagnifyingGlass size={32} /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="#000000"
                viewBox="0 0 256 256"
              >
                <path d="M137.54,186.36a8,8,0,0,1,0,11.31l-9.94,10A56,56,0,0,1,48.38,128.4L72.5,104.28A56,56,0,0,1,149.31,102a8,8,0,1,1-10.64,12,40,40,0,0,0-54.85,1.63L59.7,139.72a40,40,0,0,0,56.58,56.58l9.94-9.94A8,8,0,0,1,137.54,186.36Zm70.08-138a56.08,56.08,0,0,0-79.22,0l-9.94,9.95a8,8,0,0,0,11.32,11.31l9.94-9.94a40,40,0,0,1,56.58,56.58L172.18,140.4A40,40,0,0,1,117.33,142,8,8,0,1,0,106.69,154a56,56,0,0,0,76.81-2.26l24.12-24.12A56.08,56.08,0,0,0,207.62,48.38Z"></path>
              </svg>
            </TextInput.Icon>
            <TextInput.Input
              className="text-lg cursor-text input-copy-link-share"
              value={url}
              disabled
            />
          </TextInput.Root>
          {successCopyLink != null && (
            <>
              {!successCopyLink ? (
                <div className="text-center text-red-900 font-semibold">
                  Falha ao copiar o link! Tente manualmente.
                </div>
              ) : (
                <div className="text-center text-green-900 font-semibold">
                  Link copiado com sucesso!
                </div>
              )}
            </>
          )}
        </div>
        <Button variant="primary" className="mt-3" onClick={handleCopy} fontSizeClassName="text-s">
          Copiar Link
        </Button>
        {/* <button className="close-button" onClick={onClose}>
          Copiar Link
        </button> */}
      </div>
    </div>
  )
}

export default ShareModal
